<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>


export default {
  name: 'App',
  mounted() {
    document.addEventListener('contextmenu', function(e) {
        e.preventDefault();
    });
  }
  
}
</script>

<style>
* {
  -webkit-user-select: none; /* 禁止webkit浏览器（如Safari）的文本选择 */  
  -khtml-user-select: none; /* 禁止早期浏览器的文本选择 */  
  -moz-user-select: none; /* 禁止火狐浏览器的文本选择 */  
  -ms-user-select: none; /* 禁止IE10的文本选择 */  
  user-select: none; /* 禁止所有支持此属性的浏览器的文本选择 */ 
}
html {
  margin: 0;
  padding: 0;
}
body {
  margin: 0;
  padding: 0;
  overflow: hidden;
  -webkit-text-size-adjust: 100% !important;
}
</style>
